import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  expertManagement,
  learnerManagement,
  updateExpertUserStatus,
  updateuser,
  updateUserStatus,
  userPageCounts,
} from "../../Redux/expertSlice";
import {
  FaExchangeAlt,
  FaUsers,
  FaUserTie,
  FaUserGraduate,
  FaUserCheck,
  FaUserCog,
  FaChartLine,
  FaUserPlus,
  FaUserMinus,
} from "react-icons/fa";
import {
  FiUsers,
  FiUserCheck as FiUserCheck2,
  FiAward,
  FiBookOpen,
  FiCalendar,
  FiMail,
  FiStar,
  FiMoreVertical,
  FiEdit2,
  FiEye,
  FiLock,
  FiUnlock,
  FiFilter,
  FiSearch,
  FiRefreshCw,
  FiUser,
  FiBarChart2,
} from "react-icons/fi";
import {
  MdOutlineVerified,
  MdOutlineBlock,
  MdOutlineEdit,
} from "react-icons/md";
import card1icon from "../../public/images/card1.svg";
import card2icon from "../../public/images/card2.svg";
import card3icon from "../../public/images/card3.svg";
import card4icon from "../../public/images/card4.svg";
import LearningMangmentTable from "./Table/UserMangmentTable";
import DeletModal from "../../components/Delete Modal/DeletModal";
import ViewModal from "./LearnerModal/ViewModal";
import EditModal from "./LearnerModal/EditModal";
import Button from "../../components/Button/Button";
import Card from "../../components/Card/Card";
import ExpertMangmentTable from "./Table/ExpertMangmentTable.js";
import Loader from "../../components/Loader/Loader.js";
import { useLocation, useNavigate } from "react-router";
import { toast } from "react-toastify";

function Learnermanagement() {
  const dispatch = useDispatch();
  const selector = useSelector((state) => state);
  const location = useLocation();
  const navigate = useNavigate();
  let queryParams = new URLSearchParams(location.search);
  const initialTab = queryParams.get("tab") || "LearnersManagement";
  const [pageNo, setPageNo] = useState(1);
  const [size, setSize] = useState(8);
  const [pageNo1, setPageNo1] = useState(1);
  const [size1, setSize1] = useState(8);
  const [offset, setOffset] = useState(0);
  const [offset1, setOffset1] = useState(0);

  const [keyword, setkeyword] = useState("");
  const [activeStatus, setActiveStatus] = useState("");
  const [activeStatus2, setActiveStatus2] = useState("");
  const [learnerSortKey, setLearnerSortKey] = useState("createdAt");
  const [learnerSortOrder, setLearnerSortOrder] = useState("desc");
  const [expertSortKey, setExpertSortKey] = useState("createdAt");
  const [expertSortOrder, setExpertSortOrder] = useState("desc");
  const [activeTab, setActiveTab] = useState(initialTab);
  const [error, setError] = useState({});

  const {
    expertSlice: {
      loading,
      learners,
      totalLearner,
      totalExpert,
      experts,
      userCounts,
    },
  } = selector ? selector : {};

  const [isEditModal, setIsEditModal] = useState(false);
  const [isBlockModal, setIsBlockModal] = useState(false);
  const [isSelectedReason, setIsSelectedReason] = useState(null);
  const [commentsForLearner, setIsCommentsForLearner] = useState(null);
  const [isLearnerViewModal, setIslearnerViewModal] = useState(false);

  const [ViewModalData, setIsViewModalData] = useState(null);
  const [editData, setEditData] = useState({});
  const [blockData, setBlockData] = useState({});

  const [isMenu, setIsMenu] = useState(false);
  const [clickedUserId, setClickedUserId] = useState(null);

  /// Expert State=====>
  const [expertKeyword, setExpertkeyword] = useState("");
  const [isExpertViewModal, setIsExpertViewModal] = useState(false);
  const [isExpertEditModal, setIsExpertEditModal] = useState(false);
  const [isExpertStatusUpdateModal, setIsExpertStatusUpdateModal] =
    useState(false);

  const learnerTableHead = [
    { label: "#", sortKey: null },
    { label: "Learner Name", sortKey: "fullName" },
    { label: "Email", sortKey: "email" },
    { label: "Course Enrolled", sortKey: "courseBuyed" },
    { label: "Course Completed", sortKey: "courseCompleted" },
    { label: "Status", sortKey: "isDisable" },
    { label: "Join Date", sortKey: "createdAt" },
    { label: "Action", sortKey: null },
  ];
  const expertTableHeader = [
    { label: "#", sortKey: null },
    { label: "Expert Name", sortKey: "fullName" },
    { label: "Courses Created", sortKey: "totalCourse" },
    { label: "Rating (Avg)", sortKey: "rating" },
    { label: "Status", sortKey: "isDisable" },
    { label: "Join Date", sortKey: "createdAt" },
    { label: "Action", sortKey: null },
  ];
  const selectedReason = [
    { value: "Policy_Violation", label: "Policy Violation" },
    { value: "Quality_Issues", label: "Quality Issues" },
    { value: "Other", label: "Other" },
  ];

  useEffect(() => {
    let apiRequestData = {
      keyWord: keyword,
      fromDate: "",
      toDate: "",
      sortBy: learnerSortKey,
      sortOrder: learnerSortOrder,
      pageNo: pageNo,
      size: size,
      disable_type: activeStatus ? activeStatus : "",
    };

    dispatch(learnerManagement(apiRequestData));
    let apiRequestData2 = {
      keyWord: expertKeyword,
      fromDate: "",
      toDate: "",
      sortBy: expertSortKey,
      sortOrder: expertSortOrder,
      pageNo: pageNo1,
      size: size1,
      disable_type: activeStatus2 ? activeStatus2 : "",
    };

    dispatch(expertManagement(apiRequestData2));
    navigate(`?tab=${activeTab}`);
  }, [
    activeTab,
    navigate,
    keyword,
    activeStatus,
    activeStatus2,
    expertKeyword,
    dispatch,
    pageNo,
    pageNo1,
    size,
    size1,
    learnerSortKey,
    learnerSortOrder,
    expertSortKey,
    expertSortOrder,
  ]);

  useEffect(() => {
    dispatch(userPageCounts({}));
  }, [dispatch]);

  const handleFilter = (e) => {
    setActiveStatus(e.target.value);
    setPageNo(1);
    setOffset(0);
  };

  const handleFilter1 = (e) => {
    setActiveStatus2(e.target.value);
    setPageNo1(1);
    setOffset1(0);
  };

  const handleLearnerSort = (key) => {
    setLearnerSortOrder((previousOrder) =>
      learnerSortKey === key && previousOrder === "asc" ? "desc" : "asc",
    );
    setLearnerSortKey(key);
    setPageNo(1);
    setOffset(0);
  };

  const handleExpertSort = (key) => {
    setExpertSortOrder((previousOrder) =>
      expertSortKey === key && previousOrder === "asc" ? "desc" : "asc",
    );
    setExpertSortKey(key);
    setPageNo1(1);
    setOffset1(0);
  };

  const toggleExpertViewModal = () => {
    setIsExpertViewModal((prevState) => !prevState);
  };

  const handleEdit = (data) => {
    setIsEditModal(!isEditModal);
    setEditData(data);
  };

  const toggleEditModal = () => {
    setIsEditModal(!isEditModal);
  };

  const handleONChange = (e) => {
    const { name, value } = e.target;
    setEditData({
      ...editData,
      [name]: value,
    });
    setIsViewModalData({
      ...ViewModalData,
      [name]: value,
    });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    let pageReferesh = {
      keyWord: keyword,
      fromDate: "",
      toDate: "",
      sortBy: learnerSortKey,
      sortOrder: learnerSortOrder,
      pageNo: pageNo,
      size: size,
      disable_type: activeStatus ? activeStatus : "",
    };

    let editDataCred = {
      userId: editData?._id,
      fullName: editData?.fullName || null,
      email: editData.email,
    };

    let apiRequestData2 = {
      keyWord: expertKeyword,
      fromDate: "",
      toDate: "",
      sortBy: expertSortKey,
      sortOrder: expertSortOrder,
      pageNo: pageNo1,
      size: size1,
      disable_type: activeStatus2 ? activeStatus2 : "",
    };

    dispatch(
      updateuser({
        Payload: editDataCred,
        forReferesh: pageReferesh,
        apiRequestData2: apiRequestData2,
      }),
    );
    setIsEditModal(false);
    setEditData(null);
  };

  const handleUserBlock = (data) => {
    setBlockData(data);
    setIsBlockModal(!isBlockModal);
  };

  const toggleBlockModal = () => {
    setIsBlockModal(!isBlockModal);
    setIsCommentsForLearner("");
    setIsSelectedReason("");
    setError({})
  };

  const handleSelectReason = (selected) => {
    setIsSelectedReason(selected);
  };

  const handleCommentsOnChnage = (e) => {
    setIsCommentsForLearner(e.target.value);
    if (error.comments) setError((prev) => ({ ...prev, comments: null }));
  };

  const handleBlockSubmit = (e) => {
    e.preventDefault();

    if(!blockData?.isDisable) {

      const newErrors = {};

      if (!isSelectedReason || isSelectedReason.trim() === "") {
        newErrors.reason = "Please select a reason";
      }

      if (!commentsForLearner || commentsForLearner.trim() === "") {
        newErrors.comments = "Please enter your comments";
      }

      // If there are errors, update state and stop submission
      if (Object.keys(newErrors).length > 0) {
        setError(newErrors);
        return;
      }
    }


    // Clear any previous errors
    setError({});

    let pageReferesh = {
      keyWord: keyword,
      fromDate: "",
      toDate: "",
      sortBy: learnerSortKey,
      sortOrder: learnerSortOrder,
      pageNo: pageNo,
      size: size,
      disable_type: activeStatus ? activeStatus : "",
    };

    let blockCred = {
      userId: blockData?._id,
      blockComment: blockData?.isDisable ? "" : commentsForLearner,
      blockReason: blockData?.isDisable ? "" : isSelectedReason,
    };

    let apiRequestData2 = {
      keyWord: expertKeyword,
      fromDate: "",
      toDate: "",
      sortBy: expertSortKey,
      sortOrder: expertSortOrder,
      pageNo: pageNo1,
      size: size1,
      disable_type: activeStatus2 ? activeStatus2 : "",
    };

    dispatch(
      updateUserStatus({
        Payload: blockCred,
        forReferesh: pageReferesh,
        apiRequestData2: apiRequestData2,
      }),
    )
      .then((res) => {
        if (res) {
          toast.success(res?.payload?.message);
        }
      })
      .catch((err) => {
        toast.error(err?.message);
      });
    setIsBlockModal(false);
    setIsCommentsForLearner("");
    setIsSelectedReason("");
    setError({});
  };

  const showMenu = (userId) => {
    if (clickedUserId === userId) {
      setIsMenu(!isMenu);
    } else {
      setClickedUserId(userId);
      setIsMenu(true);
    }
  };

  const handleViewLearner = (data) => {
    setIsViewModalData(data);
    setIslearnerViewModal(true);
  };

  const handleExpertAction = (action, data) => {
    setIsViewModalData(data);
    switch (action) {
      case "STATUS":
        setIsExpertStatusUpdateModal((prevState) => !prevState);
        break;
      case "VIEW":
        setIsExpertViewModal((prevState) => !prevState);
        break;
      case "EDIT":
        setIsExpertEditModal((prevState) => !prevState);
        break;
      default:
        break;
    }
  };

  const toggleEditExpertModal = () => {
    setIsExpertEditModal((prevState) => !prevState);
    setIsViewModalData(null);
  };

  const handleEditExpertOnChnage = (e) => {
    const { name, value } = e.target;
    setIsViewModalData({ ...ViewModalData, [name]: value });
  };

  const handlePageClick = (data) => {
    const newPageNo = data.selected + 1;
    setOffset(data.selected * size);
    setPageNo(newPageNo);
  };

  const handlePageClick2 = (data) => {
    const newPageNo = data.selected + 1;
    setPageNo1(newPageNo);
    setOffset1(data.selected * size1);
  };

  const toggleLearnerViewModal = () => {
    setIslearnerViewModal(false);
    setIsViewModalData(null);
  };

  const handleExperEdit = (e) => {
    e.preventDefault();
    let pageReferesh = {
      keyWord: keyword,
      fromDate: "",
      toDate: "",
      sortBy: learnerSortKey,
      sortOrder: learnerSortOrder,
      pageNo: pageNo,
      size: size,
      disable_type: activeStatus ? activeStatus : "",
    };

    let editDataCred = {
      userId: ViewModalData?._id,
      fullName: ViewModalData?.fullName || null,
      skill: ViewModalData.skill,
    };

    let apiRequestData2 = {
      keyWord: expertKeyword,
      fromDate: "",
      toDate: "",
      sortBy: expertSortKey,
      sortOrder: expertSortOrder,
      pageNo: pageNo1,
      size: size1,
      disable_type: activeStatus2 ? activeStatus2 : "",
    };

    dispatch(
      updateuser({
        Payload: editDataCred,
        forReferesh: pageReferesh,
        apiRequestData2: apiRequestData2,
      }),
    );
    setIsEditModal(false);
    setIsExpertEditModal((prev) => !prev);
    setEditData(null);
  };

  const handleBlockExpertSubmit = () => {
    let pageReferesh = {
      keyWord: keyword,
      fromDate: "",
      toDate: "",
      sortBy: learnerSortKey,
      sortOrder: learnerSortOrder,
      pageNo: pageNo,
      size: size,
      disable_type: activeStatus ? activeStatus : "",
    };

    let apiRequestData2 = {
      keyWord: expertKeyword,
      fromDate: "",
      toDate: "",
      sortBy: expertSortKey,
      sortOrder: expertSortOrder,
      pageNo: pageNo1,
      size: size1,
      disable_type: activeStatus2 ? activeStatus2 : "",
    };

    let blockCred = {
      userId: ViewModalData?._id,
      blockComment: commentsForLearner,
      blockReason: isSelectedReason,
    };

    dispatch(
      updateExpertUserStatus({
        Payload: blockCred,
        forReferesh: pageReferesh,
        apiRequestData2: apiRequestData2,
      }),
    );
    setIsExpertStatusUpdateModal(false);
    setIsCommentsForLearner("");
    setIsSelectedReason("");
    setError({});
  };

  const toggleExpertBlockModal = () => {
    setIsExpertStatusUpdateModal(false);
  };

  // Card data with icons
  const cardData = [
    {
      title: "Total Learners",
      count: userCounts?.Total_Learners || 0,
      icon: FiUsers,
      img: card1icon,
      color: "from-blue-500 to-blue-600",
    },
    {
      title: "Total Experts",
      count: userCounts?.Total_Experts || 0,
      icon: FiUserCheck2,
      img: card2icon,
      color: "from-purple-500 to-purple-600",
    },
    {
      title: "Active Learners",
      count: userCounts?.Total_Active_Learners || 0,
      icon: FaUserGraduate,
      img: card3icon,
      color: "from-emerald-500 to-emerald-600",
    },
    {
      title: "Active Experts",
      count: userCounts?.Total_Active_Experts || 0,
      icon: FaUserTie,
      img: card4icon,
      color: "from-rose-500 to-rose-600",
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Loader loading={loading} />

      {/* Header Banner */}
      <div className="bg-gradient-to-r from-[#855DF6] via-[#7B5CF6] to-[#715EFE] shadow-lg relative overflow-hidden">
        {/* Decorative elements */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -mr-20 -mt-20"></div>
        <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/5 rounded-full -ml-12 -mb-12"></div>
        <div className="absolute top-1/2 left-1/2 w-96 h-96 bg-white/5 rounded-full -translate-x-1/2 -translate-y-1/2"></div>

        <div className="relative z-10 px-4 md:px-7 py-4 md:py-6">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <div className="flex items-center gap-3">
              <div className="p-2 bg-white/20 rounded-lg backdrop-blur-sm">
                <FiUsers className="w-5 h-5 text-white md:w-6 md:h-6" />
              </div>
              <div>
                <h2 className="text-xl font-bold text-white md:text-2xl dahboardFont">
                  User Management
                </h2>
                <p className="text-sm text-white/70 hidden sm:block">
                  Manage learners and experts across the platform
                </p>
              </div>
            </div>
            {/* <div className="flex items-center gap-2">
              <span className="px-3 py-1 text-xs text-white bg-white/20 rounded-full backdrop-blur-sm">
                <FiRefreshCw className="inline w-3 h-3 mr-1" />
                {new Date().toLocaleDateString()}
              </span>
            </div> */}
          </div>

          {/* Stats Cards */}
          <div className="grid grid-cols-2 gap-3 mt-4 sm:grid-cols-2 lg:grid-cols-4 md:gap-4">
            {cardData.map((card, index) => (
              <div
                key={index}
                className="bg-white/10 backdrop-blur-sm rounded-xl p-3 md:p-4 border border-white/20 hover:bg-white/20 transition-all duration-300"
              >
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-lg font-bold text-white uppercase md:text-lg">
                      {card.title}
                    </p>
                    <p className="text-lg font-bold text-white md:text-2xl">
                      {card.count}
                    </p>
                  </div>
                  <div
                    className={`p-2 rounded-lg bg-gradient-to-br ${card.color} bg-opacity-30`}
                  >
                    <card.icon className="w-4 h-4 text-white md:w-5 md:h-5" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Main Content */}
      <section className="px-3 py-4 -mt-4 md:px-6 lg:px-10 md:py-6">
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
          {/* Tab Navigation */}
          <div className="flex flex-col sm:flex-row border-b border-gray-100 bg-gray-50/50">
            <button
              className={`
                flex items-center gap-2 px-4 py-3 text-sm font-medium transition-all duration-200
                ${
                  activeTab === "LearnersManagement"
                    ? "text-[#715EFE] border-b-2 border-[#715EFE] bg-white"
                    : "text-gray-500 hover:text-gray-700 hover:bg-gray-100/50"
                }
              `}
              onClick={() => {
                setActiveTab("LearnersManagement");
                handlePageClick({ selected: 0 });
              }}
            >
              <FiUsers className="w-4 h-4" />
              <span>Learners Management</span>
              {userCounts?.Total_Learners > 0 && (
                <span className="px-1.5 py-0.5 text-xs font-medium text-[#715EFE] bg-[#715EFE]/10 rounded-full">
                  {userCounts.Total_Learners}
                </span>
              )}
            </button>
            <button
              className={`
                flex items-center gap-2 px-4 py-3 text-sm font-medium transition-all duration-200
                ${
                  activeTab === "ExpertsManagement"
                    ? "text-[#715EFE] border-b-2 border-[#715EFE] bg-white"
                    : "text-gray-500 hover:text-gray-700 hover:bg-gray-100/50"
                }
              `}
              onClick={() => {
                setActiveTab("ExpertsManagement");
                handlePageClick2({ selected: 0 });
              }}
            >
              <FiUserCheck2 className="w-4 h-4" />
              <span>Experts Management</span>
              {userCounts?.Total_Experts > 0 && (
                <span className="px-1.5 py-0.5 text-xs font-medium text-[#715EFE] bg-[#715EFE]/10 rounded-full">
                  {userCounts.Total_Experts}
                </span>
              )}
            </button>
          </div>

          {/* Table Content */}
          <div className="p-3 md:p-4">
            {activeTab === "LearnersManagement" ? (
              <LearningMangmentTable
                TableHeader={learnerTableHead}
                TableName={`Learner List`}
                TableData={learners}
                isMenu={isMenu}
                clickedUserId={clickedUserId}
                showMenu={showMenu}
                total={totalLearner}
                size={size}
                handleEdit={handleEdit}
                handleUserBlock={handleUserBlock}
                handlePageClick={handlePageClick}
                offset={offset}
                handleViewLearner={handleViewLearner}
                setkeyword={setkeyword}
                keyword={keyword}
                handleFilter={handleFilter}
                currentSortKey={learnerSortKey}
                currentSortOrder={learnerSortOrder}
                onSort={handleLearnerSort}
              />
            ) : (
              <ExpertMangmentTable
                activeStatus={activeStatus2}
                handleFilter={handleFilter1}
                TableHeader={expertTableHeader}
                TableName={`Experts List`}
                TableData={experts}
                handlePageClick={handlePageClick2}
                size={size1}
                total={totalExpert}
                offset={offset1}
                handleExpertAction={handleExpertAction}
                setExpertkeyword={setExpertkeyword}
                expertKeyword={expertKeyword}
                handleUserBlock={handleUserBlock}
                currentSortKey={expertSortKey}
                currentSortOrder={expertSortOrder}
                onSort={handleExpertSort}
              />
            )}
          </div>
        </div>
      </section>

      {/* Modals */}
      {isEditModal && (
        <EditModal
          onCancel={toggleEditModal}
          EditData={editData}
          handleONChange={handleONChange}
          onSubmit={onSubmit}
          title={`Edit Learner`}
          icon={<MdOutlineEdit className="w-5 h-5 text-[#715EFE]" />}
        />
      )}

      {isBlockModal && (
        <DeletModal
          blockData={blockData}
          title={`Block User`}
          title1={null}
          isOpen={isBlockModal}
          buttonName={`Submit`}
          icon={
            <MdOutlineBlock className="w-8 h-8 text-rose-500 md:w-10 md:h-10" />
          }
          onCancel={toggleBlockModal}
          onDelete={handleBlockSubmit}
          options={selectedReason}
          onChange={handleSelectReason}
          selectedReason={isSelectedReason}
          commentsForLearner={commentsForLearner}
          handleCommentsOnChnage={handleCommentsOnChnage}
          error={error}
        />
      )}

      {isExpertViewModal && (
        <ViewModal
          isOpen={isExpertViewModal}
          ViewModalData={ViewModalData}
          onCancel={toggleExpertViewModal}
          title={ViewModalData?.fullName}
        />
      )}

      {isExpertEditModal && (
        <EditModal
          title={"Edit Expert"}
          EditData={ViewModalData}
          onCancel={toggleEditExpertModal}
          handleONChange={handleEditExpertOnChnage}
          onSubmit={handleExperEdit}
          icon={<MdOutlineEdit className="w-5 h-5 text-[#715EFE]" />}
        />
      )}

      {isExpertStatusUpdateModal && (
        <DeletModal
          blockData={blockData}
          title={`Block/Unblock Expert`}
          isOpen={isExpertStatusUpdateModal}
          buttonName={`Submit`}
          icon={
            <MdOutlineBlock className="w-8 h-8 text-rose-500 md:w-10 md:h-10" />
          }
          onCancel={toggleExpertBlockModal}
          onDelete={handleBlockExpertSubmit}
          options={selectedReason}
          onChange={handleSelectReason}
          selectedReason={isSelectedReason}
          commentsForLearner={commentsForLearner}
          handleCommentsOnChnage={handleCommentsOnChnage}
          error={error}
        />
      )}

      {isLearnerViewModal && (
        <ViewModal
          isOpen={isLearnerViewModal}
          ViewModalData={ViewModalData}
          onCancel={toggleLearnerViewModal}
          title={ViewModalData?.fullName}
        />
      )}
    </div>
  );
}

export default Learnermanagement;
